import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axios from "axios";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

// const DEMO_URL = "https://jsonplaceholder.typicode.com/todos/1";
const END_POINT = process.env.REACT_APP_END_POINT_UPDATE_USER_PROFILE;

export const patchForProfileInfo = createAsyncThunk(
  "patch/user/profile/info",
  async (patchData, thunkAPI) => {
    try {
      //   const result = await axios.get(DEMO_URL);
      //   return result.data;
      const result = fetchInterceptors(END_POINT, "PATCH", patchData);
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const patchForProfileInfoSlice = createSlice({
  name: "patchForProfileInfoSlice",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: null,
  },
  reducers: {
    setDefaultPatchProfileInfoSate: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(patchForProfileInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(patchForProfileInfo.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(patchForProfileInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefaultPatchProfileInfoSate } =
  patchForProfileInfoSlice.actions;

export default patchForProfileInfoSlice.reducer;
